import React from 'react';

import * as Tabs from 'components/tabs';
import * as List from 'components/list';
import * as Page from 'components/page';
import * as Form from 'components/form';

import UserAvatar from 'core/components/user/avatar/UserAvatar';

import * as Styled from './StyledComponents';

// import { InvestmentCard } from './investment/InvestmentCard';

export const InvestmentSection = props => {
    const { form } = props;
    const { vars, deleteInvestment, saveEditedFields } = props.useStartupId;
    const { investments } = vars;

    const InvestmentCard = ({ data }) => {
        const investment = data;
        const { investor } = data;

        const handleDelete = () => {
            deleteInvestment(investment._id);
        };

        return (
            <Styled.FounderCard>
                <UserAvatar
                    user={{
                        firstName: investor.name || investor.companyName,
                        photoUrl: investor.data.photoUrl,
                    }}
                />
                <Styled.CardInfos>
                    <div className="card-header">
                        <span className="name">{investor.name}</span>
                        <span
                            style={{ cursor: 'pointer' }}
                            onClick={handleDelete}
                            className="icon far fa-times"
                            aria-hidden="true"
                        />
                    </div>
                    <span className="text">{investor.email}</span>
                    <span className="text">{investor.companyName}</span>
                    {/* <span className="text">{founder.linkedin}</span> */}
                    {/* <a href={founder.linkedin} className="text">
                        {founder.linkedin}
                    </a> */}
                </Styled.CardInfos>
            </Styled.FounderCard>
        );
    };

    const fields = {
        externalInvestment: {
            error: form.errors.externalInvestment,
            label: props.t('InvestmentSection.externalInvestment'),
            name: 'externalInvestment',
            type: 'YesNo',
            value: form.values.externalInvestment,
            onChange: form.handleChange,
        },
    };

    return (
        <>
            <Page.Descr>{props.t('InvestmentSection.title')}</Page.Descr>
            <Form.Field {...fields.externalInvestment} />

            <Styled.TabsContainer>
                <Tabs.TabsContainer>
                    <Tabs.TabsButtons>
                        <Tabs.Tab name="Investment">{props.t('InvestmentSection.title')}</Tabs.Tab>
                    </Tabs.TabsButtons>

                    <List.List name="Investment">
                        <List.Vertical
                            items={investments}
                            itemKey="_id"
                            itemComponent={InvestmentCard}
                        />
                        <Styled.BtnContainer>
                            <Page.Buttn
                                to={`/startup/${vars.startupId}/investment`}
                                type="linkd btn-block"
                                onClick={() => saveEditedFields(form.values)}
                            >
                                <span className="icon far fa-plus-circle" aria-hidden="true" />
                                <span className="text">{props.t('glossary:add')}</span>
                                <span className="icon far fa-long-arrow-right" aria-hidden="true" />
                            </Page.Buttn>
                        </Styled.BtnContainer>
                    </List.List>
                </Tabs.TabsContainer>
            </Styled.TabsContainer>
        </>
    );
};

export default InvestmentSection;
